module.exports = __webpack_public_path__ + "static/media/githubLogo.90118e04.svg";